import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import { getCountries } from '../../../Reducers/Countries/actions'
import LegalDocumentForm from './LegalDocumentForm/LegalDocumentForm'
import {
  getLegalDocumentById,
  deleteLegalDocumentById,
  createLegalDocument,
} from '../../../Reducers/LegalDocument/actions'

import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'

import { LEGAL_DOCUMENT_FORM_MODES } from './const'
import { showReduxModal } from '../../../Reducers/UI/actions'
import { apiClient } from '../../../Module/API/Client'
import {
  incUIBlockCounter,
  decBlockCounter,
} from '../../../Reducers/UIBlock/actions'
import { ROLE_SPY } from '../../../shared/constants'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

const styles = {
  wrapper: { padding: '0 3rem' },
}

const BreadcrumbsCreateDocument = () => {
  return (
    <div>
      <StyledBreadcrumbs
        icon={<SettingsIcon style={{ width: 20 }} />}
        breadcrumbs={[
          {
            label: 'Settings',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
          },
          {
            label: 'Legal Documents',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
              PATHS.settings.legalDocumentation
            }`,
          },
          { label: 'Edit' },
        ]}
      />
    </div>
  )
}

const LegalDocumentationEdit = ({
  classes,
  countries,
  getCountries,
  legalDocument,
  uploadFile,
  createLegalDocument,
  deleteLegalDocumentById,
  getLegalDocumentById,
  showReduxModal,
  match,
  history,
}) => {
  useEffect(() => {
    getCountries()
    getLegalDocumentById(match.params.id)
  }, [])

  const [loading, setLoading] = useState(false)

  const navigateBack = () =>
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.legalDocumentation
      }`,
    )

  const showConfirmation = fields =>
    showReduxModal({
      title: 'Confirmation needed',
      onConfirm: () => {
        updateLegalDocument(fields)
        return // This is made to hide modal window without waiting for response to end.
      },
      children: `You are about to upload a new document. The old document will be archived. 
        All ${
          fields.userRole === ROLE_SPY ? 'Spies' : 'Brand Ambassadors'
        } in the specified country will have to accept the new list of legal documents.`,
    })

  const updateLegalDocument = async fields => {
    const { countryId, name, file, userRole } = fields
    setLoading(true)
    try {
      await deleteLegalDocumentById(legalDocument.id)

      const url = file ? await uploadFile({ file, countryId }) : fields.url

      await createLegalDocument({
        url,
        name,
        countryId,
        userRole,
      })
    } catch (e) {
      console.error(e)
      setLoading(false)
      return
    }
    navigateBack()
  }

  return (
    <div className={classes.wrapper}>
      <BreadcrumbsCreateDocument />
      {legalDocument.id == match.params.id && (
        <LegalDocumentForm
          countries={countries}
          defaultValues={legalDocument}
          mode={LEGAL_DOCUMENT_FORM_MODES.EDIT}
          handleSubmit={showConfirmation}
          handleCancel={navigateBack}
          buttonsDisabled={loading}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  legalDocument: state.legalDocument.legalDocumentById,
  countries: state.countries.countriesList,
})

const mapDispatchToProps = dispatch => ({
  getCountries: () => dispatch(getCountries()),
  getLegalDocumentById: id => dispatch(getLegalDocumentById(id)),
  showReduxModal: (...args) => dispatch(showReduxModal(...args)),
  uploadFile: async ({ countryId, file }) => {
    dispatch(incUIBlockCounter())
    const url = await apiClient.uploadLegalDocument(file, countryId)
    dispatch(decBlockCounter())
    return url
  },
  createLegalDocument: ({ countryId, name, url, userRole }) =>
    dispatch(createLegalDocument({ countryId, name, url, userRole })),
  deleteLegalDocumentById: id => dispatch(deleteLegalDocumentById(id)),
})

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(LegalDocumentationEdit)),
)
